import { AXIS_LABEL_MARGIN } from "views/components/visualizations/Constants";
import getDefaultPlotFontSettings from "views/components/visualizations/utils/getDefaultPlotFontSettings";
const getPlotXTitleSettings = (theme, config) => {
  var _a, _b, _c, _d, _e, _f;
  const visualizationAxisTitle = (config == null ? void 0 : config.visualizationConfig) && "axisConfig" in config.visualizationConfig ? (_c = (_b = (_a = config == null ? void 0 : config.visualizationConfig) == null ? void 0 : _a.axisConfig) == null ? void 0 : _b.xaxis) == null ? void 0 : _c.title : void 0;
  const visualizationAxisColor = (config == null ? void 0 : config.visualizationConfig) && "axisConfig" in config.visualizationConfig ? (_f = (_e = (_d = config == null ? void 0 : config.visualizationConfig) == null ? void 0 : _d.axisConfig) == null ? void 0 : _e.xaxis) == null ? void 0 : _f.color : void 0;
  const fontSettings = getDefaultPlotFontSettings(theme);
  const color = visualizationAxisColor != null ? visualizationAxisColor : fontSettings.color;
  return {
    text: visualizationAxisTitle,
    standoff: AXIS_LABEL_MARGIN,
    font: { ...fontSettings, color }
  };
};
export default getPlotXTitleSettings;
